import i18n from 'config/i18n';
import i18next from 'i18next';
import moment from 'moment-jalaali';
import timezones from 'data/airport-timezone.json'
import { DayValue } from 'react-modern-calendar-datepicker';
const isRTL = i18n.dir() === 'rtl';
if (isRTL) moment.loadPersian();

export const getDate = (
  date: any,
  format: string = isRTL ? 'jYYYY-jMM-jDD' : 'YYYY-MM-DD',
  inputFormat?: string
): string => {
  if (!date) return '';
  return moment(date, inputFormat).format(format);
};

export const getTimeStamp = (date: any, format: string = isRTL ? 'jYYYY-jMM-jDD' : 'YYYY-MM-DD'): number => {
  if (!date) return 0;
  if (format) return moment(date, format).unix() * 1000;
  else return moment(date).unix() * 1000;
};

export const getAlphabetDate = (date: Date | null | undefined): string => {
  if (!date) return '';
  return moment(date)
    .locale(isRTL ? 'fa' : 'en')
    .format(isRTL ? 'ddd jD jMMMM' : 'ddd D MMM');
};

export const getNextAlphabetDate = (date: Date | null | undefined, day: number): string => {
  if (!date) return '';
  return moment(date)
    .add(day, 'day')
    .format(isRTL ? 'ddd jD jMMMM' : 'ddd D MMM');
};

export const getPrevAlphabetDate = (date: Date | null | undefined, day: number): string => {
  if (!date) return '';
  return moment(date)
    .add(day * -1, 'day')
    .format(isRTL ? 'ddd jD jMMMM' : 'ddd D MMM');
};

export const getTime = (date: any, utcOffset: number = 210): string => {
  if (!date) return '';
  return moment(date).utcOffset(utcOffset).format('HH:mm');
  // return moment(date).format('HH:mm');
};

export const getOffset = (timeZone = 'UTC', date = new Date()): number => {
  const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
  const tzDate = new Date(date.toLocaleString('en-US', { timeZone }));
  return (tzDate.getTime() - utcDate.getTime()) / 6e4;
}

export const getAirportTimezone = (code ='IKA'): string => {
  return timezones[code];
}

export const getTimeInTimezone = (date:number, timeZone:string): string => {
  return new Date(date).toLocaleString('en-US', { 
    timeZone , 
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
   })
}

export const getHour = (date: any): string => {
  if (!date) return '';
  return moment(date).format('H');
};

export const getMinute = (date: any): string => {
  if (!date) return '';
  return moment(date).format('m');
};

export const durationToTime = (duration: number): string => {
  if (!duration) return '-';
  const h = Math.ceil(duration / 60);
  const m = duration % 60;
  return `${h ? h + i18next.t('constants.timeTitles.h') : ''} ${m ? m + i18next.t('constants.timeTitles.m') : ''} `;
};

export const addToDate = (
  date: Date,
  { year = 0 as number, month = 0 as number, day = 0 as number },
  format = 'YYYY-MM-DD'
): string => {
  if (!date) return '';
  return moment(date).add(year, 'year').add(month, 'month').add(day, 'day').format(format);
};

export const dayValueToDate = (
  date: DayValue,
  format: string = isRTL ? 'jYYYY-jMM-jDD' : 'YYYY-MM-DD',
  inputFormat: string = isRTL ? 'jYYYY-jMM-jDD' : 'YYYY-MM-DD'
): string => {
  if (!date) return '';
  const joinDate = `${date?.year}-${('0' + date?.month).slice(-2)}-${('0' + date?.day).slice(-2)}`;
  return getDate(joinDate, format, inputFormat);
};
